export default __webpack_public_path__ + "static/media/37_photo.adfcaaf5.jpg";